import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";

import { BsTrash } from "react-icons/bs";
import { useForm } from "react-hook-form";

import { 
  CheckboxDropdownMenu, 
  Button
} from "@evos/components";

import { t } from "i18next";

type FiltersType = {
  ocpp_status: string[];
  installation: string[];
  last_comms: string[];
  search: string[] | string;
};

type ChargerFilterBarProps = {
  darkMode: boolean;
  windowWidth: number;
  loading: boolean;
  decodedFilters: {
    ocpp_status: string[],
    installation: string[], 
    last_comms: string[]
    search: string[]
  };
  setFilters: (filters: Pick<FiltersType, "ocpp_status" | "installation" | "last_comms"> & { search: string[] }) => void;
};

export default function ChargerFilterBar({
  darkMode,
  windowWidth,
  loading,
  decodedFilters,
  setFilters
}: ChargerFilterBarProps) {

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: {
      isDirty
    },
  } = useForm<FiltersType>({
    defaultValues: {
      ocpp_status: decodedFilters.ocpp_status,
      installation: decodedFilters.installation,
      last_comms: decodedFilters.last_comms,
      search: decodedFilters.search[0] ?? "",
    },
  });

  const applyFilters = (checkedFilters: FiltersType) => {
    if (Object.values(checkedFilters).every((filter) => filter.length === 0)) {
      setFilters({ocpp_status: [], installation: [], last_comms: [], search: []});
      reset({
        ocpp_status: [],
        installation: [],
        last_comms: [],
        search: ""
      });
    } else {
      setFilters({ocpp_status: checkedFilters.ocpp_status, installation: checkedFilters.installation, last_comms: checkedFilters.last_comms, search: [checkedFilters.search] as string[]});
      reset({}, { keepValues: true});
    }
  };

  const removeFilters = () => {
    setFilters({ ocpp_status: [], installation: [], last_comms: [], search: [] });
    reset({
      ocpp_status: [],
      installation: [],
      last_comms: [],
      search: ""
    });
  };

  return (
    <Row>
      <Col xs={12}>
        <Card className={`p-4 mt-3 ${darkMode ? "bg-dark" : ""}`} style={{overflow: "visible"}}>
          <Form onSubmit={handleSubmit(applyFilters)}>
            <div className="d-flex align-items-center text-start flex-wrap gap-2">
              { windowWidth > 355 && <p className="pe-2 ps-md-2 mb-0 fw-semibold" style={{whiteSpace: "nowrap"}}>Filter by: </p> }
              <CheckboxDropdownMenu
                displayTitle="Status"
                items={["Available", "Charging", "Faulted", "Unavailable"]}
                dataTitle="ocpp_status"
                checkedState={decodedFilters.ocpp_status}
                formControl={control}
              />
              <CheckboxDropdownMenu
                displayTitle="Installation"
                items={["Installed", "Not Installed"]}
                dataTitle="installation"
                checkedState={decodedFilters.installation}
                formControl={control}
              />
              <CheckboxDropdownMenu
                displayTitle="Last Comms"
                items={["< 10 mins", "< 1 hour", "< 6 hours", "< 24 hours", "> 24 hours"]}
                dataTitle="last_comms"
                checkedState={decodedFilters.last_comms}
                formControl={control}
                isRadio
              />
              <Form.Control
                {...register("search")}
                type="text"
                style={{minWidth: "250px", width: "40%"}}
                placeholder={!loading ? "Filter by serial, name, location" : t("core.status.loading.label_dots")}
              />
              <div>
                <Button 
                  className="px-4 fw-semibold"
                  type="submit"
                  disabled={!isDirty || loading}
                  isLoading={loading}
                >
                  APPLY
                </Button>
                <Button 
                  className="ms-2 px-2 fw-semibold"
                  variant="secondary"
                  disabled={Object.values(decodedFilters).every((filterVal) => filterVal?.length === 0) || loading}
                  onClick={() => {
                    removeFilters();
                  }}
                >
                  <BsTrash />
                </Button>
              </div>
            </div>
          </Form>
        </Card>
      </Col>
    </Row>
  );
}